/* Reviv Wholesale — scroll reveal (progressive enhancement, safe in the theme editor) */
(function () {
  if (window.__revivWholesaleInit) return;
  window.__revivWholesaleInit = true;
  var root = document.documentElement;
  root.classList.add('rw-anim');
  function pending() { return Array.prototype.slice.call(document.querySelectorAll('[data-rw-reveal]:not(.rw-in)')); }
  function check() {
    var vh = window.innerHeight || 800;
    pending().forEach(function (el, i) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.94 && r.bottom > 0) {
        el.style.transitionDelay = (Math.min(i, 4) * 70) + 'ms';
        el.classList.add('rw-in');
      }
    });
  }
  function showAll() { root.classList.remove('rw-anim'); }
  check();
  var t = setInterval(function () { check(); if (!pending().length) { showAll(); clearInterval(t); } }, 150);
  setTimeout(showAll, 15000); // failsafe: never leave content hidden
  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check, { passive: true });
  document.addEventListener('shopify:section:load', function () { root.classList.add('rw-anim'); check(); });
})();
